var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserJobseekerOutcomeAction, AdviserJobseekerOutcomeFormAction, ResetAdviserGlobalFormAction, } from "../../../../redux/actions/adviser_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { Status } from "../../../../redux/constants/status";
import { getAdviserQuestionnaireProgressWidth } from "../../../../utils/questionnaireProgress";
/**
 * The Adviser Jobseeker Outcome Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserJobseekerOutcomeQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var error = useState("")[0];
    //using selector hook to fetch data from the reducer
    var _a = useSelector(function (state) { return state.rootReducer.AdviserQuestionnaireReducer; }), adviserJobseekerOutcomeData = _a.adviserJobseekerOutcomeData, status = _a.status, adviserJobseekerOutcomeFormData = _a.adviserJobseekerOutcomeFormData, success_adviserJobseekerOutcome_form = _a.success_adviserJobseekerOutcome_form;
    useEffect(function () {
        questionnaireTimer.startSection("Jobseeker Outcome");
        // Adviser Progression prefetches this section already (on second attempt);
        // only fetch if it's not already cached in the store.
        if (!adviserJobseekerOutcomeData || adviserJobseekerOutcomeData.length === 0) {
            dispatch(AdviserJobseekerOutcomeAction());
        }
    }, [dispatch]);
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    // Get the viewing_username (the jobseeker being viewed by the adviser)
    var viewing_username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Jobseeker Outcome");
        // Record Q2 total completion time
        var timingData = questionnaireTimer.onQuestionnaireComplete();
        console.log("\u2705 Q2 adviser questionnaire time: ".concat((timingData.totalSeconds / 60).toFixed(2), " minutes"));
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        // Add Q2 timing data to submission
        var submissionData = __assign(__assign({}, sanitizedData), { completion_time_seconds: Math.round(timingData.totalSeconds) });
        dispatch(AdviserJobseekerOutcomeFormAction(submissionData, loginData));
        // Clear Q2 timing data after successful submission
        questionnaireTimer.clearTimings();
    };
    var handleBackBtn = function () {
        dispatch(ResetAdviserGlobalFormAction());
        navigate("/questionnaire/adviserGlobal");
    };
    useEffect(function () {
        if (success_adviserJobseekerOutcome_form) {
            navigate("/questionnaire/transition");
        }
    }, [success_adviserJobseekerOutcome_form, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Customer Outcome", content: "", data: adviserJobseekerOutcomeData, responses: adviserJobseekerOutcomeFormData, loading: status === Status.Loading, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "global-w", width: getAdviserQuestionnaireProgressWidth("adviserJobseekerOutcome", true) })] })));
}
export default AdviserJobseekerOutcomeQuestionnaire;
